import { Strings } from "../../utils/strings";
import { isMobile } from "react-device-detect";
import TopBar from "../../components/topBar/TopBar";
import { AllMatchlist } from "./widgets/AllMatchlist";
import { useMatchListStore } from "../../store/StoreContext";
import { useFontDesk } from "../../context/frontDeskContext";
import { useEffect, useRef } from "react";
import { CustomDialog } from "../../components/dialog/CustomDialog";
import { observer } from "mobx-react-lite";
import { Colors } from "../../utils/colors";
import { TCText } from "../../components/tcText/TCText";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
const MatchList = observer(() => {
  const matchListStore = useMatchListStore();
  const { onLogOut } = useFontDesk();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      matchListStore.setDate(new Date());
      hasFetched.current = true;
    }
    return () => {
      matchListStore.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 100 && // Threshold
        !matchListStore.isLoading &&
        !matchListStore.isStopPagination
      ) {
        matchListStore.increasePageNum();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchListStore.isLoading, matchListStore.isStopPagination]);

  return (
    <div
      style={{
        paddingBottom: 30,
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative", // Added for positioning the FAB
        marginTop: 90,
      }}>
      <TopBar
        isBack={isMobile}
        onLogout={() => {
          matchListStore.modalData = {
            visible: true,
            title: Strings.LOGOUT,
            children: Strings.LOGOUT_WARNING,
            btnText: Strings.LOGOUT,
            btnVariant: "outline-danger",
            headerIcon: <div />,
            onClose: () => {
              matchListStore.modalData = undefined;
            },
            onAccept: () => {
              matchListStore.modalData = undefined;
              onLogOut();
            },
          };
        }}
        headerView={
          <div
            style={{
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 10,
              paddingBottom: 10,
              backgroundColor: Colors.background,
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
            <TCText
              value={"Matches"}
              style={{ fontSize: 18, fontWeight: 600 }}
            />
            <div style={{ flex: 1 }} />
            <DatePicker
              selected={matchListStore.date}
              onChange={(date) => {
                matchListStore.setDate(date ?? new Date());
              }}
              dateFormat="MM-dd-yyyy"
              withPortal
              placeholderText="Click to select a date"
              customInput={
                <button
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "row",
                    gap: 10,
                    alignItems: "center",
                  }}
                  title="Filter by date">
                  <TCText
                    value={format(
                      matchListStore.date ?? new Date(),
                      "MM-dd-yyyy"
                    )}
                    style={{ fontSize: 14, fontWeight: 600 }}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    style={{ color: Colors.black }}>
                    <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zm0-13H5V6h14v1z" />
                  </svg>
                </button>
              }
            />
          </div>
        }
      />

      <AllMatchlist />
      <CustomDialog
        visible={matchListStore.modalData?.visible ?? false}
        title={matchListStore.modalData?.title ?? ""}
        description={matchListStore.modalData?.children ?? ""}
        onCancel={matchListStore.modalData?.onClose}
        onConfirm={matchListStore.modalData?.onAccept}
      />
    </div>
  );
});

export default MatchList;
